export default "__VITE_ASSET__BqiHL_R0__"